import { render, staticRenderFns } from "./isiBerita.vue?vue&type=template&id=9935dd8a&"
import script from "./isiBerita.vue?vue&type=script&lang=js&"
export * from "./isiBerita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports